import { PreviewFooter, PreviewHeader } from "./components";

type PreviewLayoutProps = {
  children: React.ReactNode;
};

export const PreviewLayout = ({ children }: PreviewLayoutProps) => {
  return (
    <div className="flex flex-col min-h-dvh relative">
      <PreviewHeader />
      <main className="flex-1 pb-[60px] md:pb-0" style={{ marginTop: 140 }}>
        {children}
      </main>
      <PreviewFooter />
    </div>
  );
};
